<div class="ayuda-page">
  <div class="ayuda-header">
    <h2 class="playfair">Habla con nosotros</h2>
    <p>
      ¿Tienes preguntas o necesitas orientación? Estamos aquí para ayudarte a
      encontrar el especialista ideal para tu bienestar mental.
    </p>
  </div>

  <div class="ayuda-cards">
    <a class="ayuda-card" [href]="telefonoLink">
      <span class="ayuda-icon"><i class="fas fa-phone-alt"></i></span>
      <span class="ayuda-info">
        <span class="ayuda-label">Teléfono</span>
        <span class="ayuda-value">{{ telefono }}</span>
      </span>
    </a>

    <a class="ayuda-card" [href]="'mailto:' + email">
      <span class="ayuda-icon"><i class="fas fa-envelope"></i></span>
      <span class="ayuda-info">
        <span class="ayuda-label">Email</span>
        <span class="ayuda-value">{{ email }}</span>
      </span>
    </a>

    <a
      class="ayuda-card whatsapp"
      [href]="whatsappLink"
      target="_blank"
      rel="noopener"
    >
      <span class="ayuda-icon"><i class="fab fa-whatsapp"></i></span>
      <span class="ayuda-info">
        <span class="ayuda-label">WhatsApp</span>
        <span class="ayuda-value">{{ whatsapp }}</span>
      </span>
    </a>
  </div>
</div>
